import { transformCurrencyAmountDto } from './currency-amount';
export const transformWalletBalanceDto = _ref => {
  let {
    available_amount,
    escrow_amount
  } = _ref;
  return {
    pendingAmount: transformCurrencyAmountDto(escrow_amount),
    availableAmount: transformCurrencyAmountDto(available_amount)
  };
};
export const transformInvoiceDto = invoice => ({
  invoiceSeries: invoice.invoice_series,
  invoiceNo: invoice.invoice_no,
  invoiceDate: invoice.invoice_date,
  id: invoice.id
});